import { render, staticRenderFns } from "./MultipleSelectionSettings.vue?vue&type=template&id=fb0c064e&scoped=true"
import script from "./MultipleSelectionSettings.vue?vue&type=script&lang=js"
export * from "./MultipleSelectionSettings.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelectionSettings.vue?vue&type=style&index=0&id=fb0c064e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c064e",
  null
  
)

export default component.exports